import React, { ReactNode, useMemo } from 'react';
import { SubjectMonitoringProfileContextProvider } from '@contexts-clean/subject-monitoring-context';
import { IDataset } from '@pages-clean/central-monitoring/data-view/types';
import { LoggedInPageProps } from '@config/routes/interfaces';

export interface SubjectMonitoringContentProps {
    orgRef: string;
    studyRef: string;
    studyNumber: string;
    cm2Dataset: IDataset;
}

interface DataListingWrapperProps extends LoggedInPageProps {
    Content: ({ studyRef, cm2Dataset }: SubjectMonitoringContentProps) => ReactNode;
}

const SubjectMonitoringWrapper = ({ study, cm2Dataset, Content }: DataListingWrapperProps) => {
    const orgRef = study?.organisation?.id as string;
    const studyRef = study?.id as string;
    const studyNumber = study?.studyNumber as string;

    const smDataset: IDataset = useMemo(
        () => ({
            id: cm2Dataset?.id as number,
            dataCutDate: new Date(cm2Dataset?.dataCutDate as Date | string | number),
            created: new Date(cm2Dataset?.created as Date | string | number),
            isSmEnabledDataset: cm2Dataset?.isSmEnabledDataset ?? undefined,
        }),
        [cm2Dataset?.id, cm2Dataset?.dataCutDate, cm2Dataset?.created, cm2Dataset?.isSmEnabledDataset],
    );

    return (
        <SubjectMonitoringProfileContextProvider orgRef={orgRef} studyRef={studyRef} datasetId={smDataset.id}>
            <Content orgRef={orgRef} studyRef={studyRef} studyNumber={studyNumber} cm2Dataset={smDataset} />
        </SubjectMonitoringProfileContextProvider>
    );
};

export default SubjectMonitoringWrapper;
